<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{ route.menuName }}</span>
        <span style="color: red"> {{ form.supplierApproveStateInfo }}</span>
      </div>
      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">基础信息</span>
          </div>
          <el-row>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="no" label="跟台申请单号" v-if="getIsView()">
                <el-input disabled v-model="form.no"></el-input>
              </el-form-item>
              <span class="viewText" v-else>跟台申请单号:{{ form.no }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item label="申请时间" prop="createdTime" v-if="getIsView()">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间"
                  style="width: 100%">
                </el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>申请时间:{{ parseTime(new Date(form.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="createdUserName" label="申请人" v-if="getIsView()">
                <el-input disabled v-model="form.createdUserName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>申请人:{{ form.createdUserName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="ownerDeptName" label="所属科室" v-if="getIsView()">
                <el-input disabled v-model="form.ownerDeptName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>所属科室:{{ form.ownerDeptName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="assistant" label="跟台协助人" v-if="getIsView()">
                <el-input disabled placeholder="跟台协助人" v-model="form.assistant"></el-input>
              </el-form-item>
              <span class="viewText" v-else>跟台协助人:{{ form.assistant }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="phone" label="联系方式" v-if="getIsView()">
                <el-input disabled placeholder="联系方式" v-model="form.phone"></el-input>
              </el-form-item>
              <span class="viewText" v-else>联系方式:{{ form.phone }} </span>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="doctorName" label="手术医生" v-if="getIsView()">
                <el-select v-model="form.doctorName" placeholder="请选择" :disabled="!editMode" filterable
                  :filter-method="getUsers" @change="doctorChange" style="width: 100%">
                  <el-option v-for="item in STATIC_Users" :key="item.id" :label="item.no + ' ' + item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>手术医生:{{ form.doctorName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="surgicalStentId" label="手术名称" v-if="getIsView()">
                <el-select v-model="form.surgicalStentId" placeholder="请选择" :disabled="!editMode" filterable
                  :filter-method="getOpList" @change="opChange" style="width: 100%">
                  <el-option v-for="item in opList" :key="item.id"
                    :label="item.name + ' ' + (item.categoryName == null ? '' : item.categoryName)"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>手术名称:{{ form.surgicalStentId }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="surgeryDate" label="手术时间" v-if="getIsView()">
                <el-date-picker v-model="form.surgeryDate" :disabled="!editMode" type="datetime"
                  format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" placeholder="手术时间"
                  style="width: 100%"></el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>手术时间:{{ parseTime(new Date(form.surgeryDate), "{y}-{m}-{d} {h}:{i}") }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="patientNo" label="住院号" v-if="getIsView()">
                <el-select v-model="form.patientNo" filterable :filter-method="getPatientDetailList"
                  @change="patientChange" :disabled="!editMode" style="width: 100%">
                  <el-option v-for="item in STATIC_PatientDetails" :key="item.id" :label="item.no + ' ' + item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>住院号:{{ form.patientNo }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="patientId" label="患者姓名" v-if="getIsView()">
                <el-input disabled v-model="form.patientName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>患者姓名:{{ form.patientName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="patientSexName" label="性别" v-if="getIsView()">
                <el-input disabled v-model="form.sexName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>性别:{{ form.sexName }} </span>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="age" label="年龄" v-if="getIsView()">
                <el-input disabled v-model="form.age"></el-input>
              </el-form-item>
              <span class="viewText" v-else>年龄:{{ form.age }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="supplierIds" label="供应商" v-if="getIsView()">
                <el-select v-model="form.supplierIdArr" :disabled="!editMode" placeholder="请选择" filterable multiple
                  :filter-method="(value) => getSuppliers1(value, 1)" @change="supplierChange" style="width: 100%">
                  <el-option v-for="item in STATIC_Suppliers" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>供应商:{{ SupplierNames}} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="warehouseName" label="存放库房" v-if="getIsView()">

                <!-- <el-select v-model="form.warehouseName" :disabled="!editMode" placeholder="请选择存放库房" filterable :filter-method="getWarehousesBySessionWarehouseId" @change="warehouseChange" style="width: 100%">
                                <el-option v-for="item in STATIC_Warehouses" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select> -->


                <!-- <el-select v-if="system_setting.IsUseWard" v-model="form.warehouseName" placeholder="请选择"
                  :disabled="!editMode && !approveDisable" style="width: 100%" filterable
                  :filter-method="getWarehousesDeptWardsLevelTwo" @change="applyDeptChange1">
                  <el-option v-for="item in STATIC_Depts" :key="item.idGroup"
                    :label="item.warehouseName + ' ' + item.deptName + ' ' + (item.wardName ? item.wardName : '')"
                    :value="item.idGroup"></el-option>
                </el-select> -->
                <!-- v-else -->
                <el-select  v-model="form.warehouseName" :disabled="!editMode && !approveDisable"
                  placeholder="请选择存放库房" filterable :filter-method="getWarehouseList" @change="warehouseChange"
                  style="width: 100%">
                  <el-option v-for="item in warehouseList" :key="item.idGroup"
                    :label="item.warehouseName + ' ' + item.deptName" :value="item.idGroup"></el-option>
                </el-select>


              </el-form-item>
              <span class="viewText" v-else>存放库房:{{ form.warehouseName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="oneLevelWarehouseId" label="收货库房" v-if="getIsView()">
                <el-select v-model="form.oneLevelWarehouseName" :disabled="!editMode && !approveDisable"
                  placeholder="请选择收货库房" style="width: 100%" filterable :filter-method="getOneLevelWarehouses"
                  @change="oneLevelWarehouseChange">
                  <el-option v-for="item in STATIC_OneLevelWarehouses" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>收货库房:{{ form.oneLevelWarehouseName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="deliveryTime" label="预计到货日期" v-if="getIsView()">
                <el-date-picker v-model="form.deliveryTime" :disabled="!editMode" type="date" format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd" placeholder="预计到货日期" style="width: 100%"></el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>预计到货日期:{{  parseTime(new Date(form.deliveryTime),"{y}-{m}-{d}") }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="latestTime" label="最迟确认日期" v-if="getIsView()">
                <el-date-picker v-model="form.latestTime" :disabled="!editMode" type="date" format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd" placeholder="最迟确认日期" style="width: 100%"></el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>最迟确认日期:{{  parseTime(new Date(form.latestTime),"{y}-{m}-{d}") }} </span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="stateName" label="状态" v-if="getIsView()">
                <el-input disabled placeholder="" v-model="form.stateName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>状态:{{ form.stateName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="totalNumber" label="总数量" v-if="getIsView()">
                <el-input disabled placeholder="请输入总数量" v-model="form.totalNumber"></el-input>
              </el-form-item>
              <span class="viewText" v-else>总数量:{{ form.totalNumber }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="totalAmount" label="总金额" v-if="getIsView()">
                <el-input disabled placeholder="请输入总金额" v-model="form.totalAmount"></el-input>
              </el-form-item>
              <span class="viewText" v-else>总金额:{{ form.totalAmount }} </span>
            </el-col>
            <el-col :span="8" :class="!getIsView()?'viewCol':''">
              <el-form-item label="备注" prop="remark" v-if="getIsView()">
                <el-input :disabled="!editMode" placeholder="备注" v-model="form.remark"></el-input>
              </el-form-item>
              <span class="viewText" v-else>备注:{{ form.remark }} </span>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px"></el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">申请明细</span>
          </div>

          <div v-if="editMode" style="margin: 20px 0 12px 10px">
            <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
            <el-button class="btn" size="small" :disabled="childMultiple" v-preventReClick type="danger"
              @click="handleDeleteChildForm">删除</el-button>
          </div>
          <div v-else style="margin-top: 20px"></div>

          <el-table ref="childTable" border :data="form.details" style="width: auto; margin: 0 10px"
            @cell-dblclick="cellDblclick" @selection-change="handleChildSelectionChange" stripe
            :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column type="index" width="50" fixed> </el-table-column>
            <el-table-column type="selection" width="55" align="center" fixed></el-table-column>
            <el-table-column prop="productName" label="产品" fixed width="180">
              <template slot-scope="scope">
                <SelectTable :disabled="!editMode" :columns="supplierProductColumns" :placeholder="'请选择产品'"
                  :innerName="scope.row.productName" :dataList="STATIC_SupplierProducts" @filterMethod="getProductList"
                  @change="(val) => productChange(scope.row, val)" />
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="specName" fixed label="产品规格" width="180"></el-table-column>
            <el-table-column prop="supplierProductNo" label="供应商产品编码" width="180"></el-table-column>
            <!-- <el-table-column prop="brand" label="品牌" width="120"></el-table-column> -->
            <el-table-column prop="unit" label="包装单位" width="100"></el-table-column>
            <el-table-column prop="minUnit" label="最小单位" width="100"></el-table-column>
            <el-table-column show-overflow-tooltip prop="manufacturerName" label="生产厂家" width="180"></el-table-column>
            <el-table-column show-overflow-tooltip prop="supplierName" label="供应商" width="180"></el-table-column>
            <el-table-column prop="number" label="数量" min-width="130">
              <template slot-scope="scope">
                <el-input :disabled="!editMode" placeholder="请输入数量" type="number" :id="'number' + scope.$index" min="0"
                  @input="childNumberChange(scope.row)" v-model="scope.row.number"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="orderNumber" label="接单数量" width="100"></el-table-column>
            <el-table-column prop="undeliveredNumber" label="未配送数量" width="100"></el-table-column>
            <el-table-column prop="unCheckedNumber" label="未验收数量" width="100" />
            <el-table-column prop="price" label="单价" width="140"></el-table-column>
            <el-table-column prop="amount" label="小计" width="140"></el-table-column>
            <el-table-column prop="productCode" label="商品代码" width="100"></el-table-column>
            <el-table-column prop="newProductId"  label="平台产品id" width="100"></el-table-column>
            <el-table-column prop="minPrice" v-if="this.system_setting.isUsePriceMonitor" label="平台最低价"
              width="100"></el-table-column>
            <el-table-column prop="medicalInsuranceCategoryNo" show-overflow-tooltip label="医保代码"
              width="200"></el-table-column>
            <el-table-column prop="remark" label="备注" min-width="200">
              <template slot-scope="scope">
                <el-input :disabled="!editMode" placeholder="请输入备注" v-model="scope.row.remark"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>
    </div>
    <div slot="footer" class="footer-bottom">
      <template v-if="form.state == 2">
        <el-button class="btn primary" type="primary" v-preventReClick @click="confirmOrder">同意部分接单</el-button>
        <el-button class="btn default" v-preventReClick @click="cancelOrder">拒绝部分接单</el-button>
      </template>
      <template v-else>
        <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
        <my-button v-if="editMode && form.status != 0" class="btn primary" type="primary" v-preventReClick
          @click="proTemSave">暂 存</my-button>
        <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
        <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确
          定</my-button>
        <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
      </template>
    </div>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import {
  GetSurgicalStents,
  GetSurgicalStentById,
  GetSurgicalApplyById,
  SaveSurgicalApply,
  RejectSurgicalApply,
  CancelSurgicalApply,
  ConfirmSurgicalApply,
  ValidateSupplierProducts,
  GetWarehousesDepts
} from "@/api";
// import { InStockOptions, WhetherOptions, AssetSourceOptions } from "@/enum";
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";
import { Debounce } from '@/utils/utils'
export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin, GetDataSpdMixin],
  components: {
    SelectTable,
    ApproveInfo,
  },
  data () {
    return {
      GetDataAction: GetSurgicalApplyById,
      SaveDataAction: SaveSurgicalApply,
      reject: RejectSurgicalApply,

      form: {},
      // InStockOptions: InStockOptions,
      // WhetherOptions: WhetherOptions,
      // AssetSourceOptions: AssetSourceOptions,
      rules: {
        patientId: [{
          required: true,
          message: "请选择患者",
          trigger: "blur",
        },],
        surgicalStentId: [{
          required: true,
          message: "请选择手术",
          trigger: "blur",
        },],
        surgeryDate: [{
          required: true,
          message: "请选择手术时间",
          trigger: "blur",
        },],
        doctorName: [{
          required: true,
          message: "请选择手术医生",
          trigger: "blur",
        },],
        patientNo: [{
          required: true,
          message: "请选择住院号",
          trigger: "blur",
        },],
        warehouseName: [{
          required: true,
          message: "请选择存放库房",
          trigger: "blur",
        },],
        supplierIds: [{
          required: true,
          message: "请选择供应商",
          trigger: "blur",
        },],
        oneLevelWarehouseId: [{
          required: true,
          message: "请选择收货库房",
          trigger: "blur",
        },],
      },
      childFormRules: {
        price: [{
          required: true,
          message: "请输入采购价",
          trigger: "blur",
        },],
        number: [{
          required: true,
          message: "数量不能为空",
          trigger: "blur",
        },
        {
          type: "number",
          min: 0.01,
          message: "数量必须大于0",
          trigger: "blur",
        },
        ],
      },
      editMode: false,
      showWorkFlowInfo: false,
      assetList: [],
      approveDisable: false,
      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      childForm: {},
      // showCapitalSource: false,
      // showCapitalSourceTwo: false,
      // showCapitalSourceThree: false,
      // capitalSourcemaxCount: 0,
      // fileId: 0,
      // fileName: '',
      // openViewer: false,
      opList: [],
      warehouseList: [],
      SupplierNames:''
    };
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }

    if (query.isCopy == 1) {
      this.isCopy = true;
    }

    // if (query.editMode == 1) {
    //   this.editMode = true
    // }
    this.getSuppliers1("", 1);
    this.getProductList("");
    this.getPatientDetailList("");
    this.getOpList("");
    this.getUsers("");
    this.getWarehouseList('')
    // this.getWarehouses('')
    this.getWarehousesBySessionWarehouseId("");
    this.getOneLevelWarehouses("");
  },
  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      this.GetDataAction({
        id,
      }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        this.getLocations(this.form.warehouseId);
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });

        this.initWorkFlowProperty(this.form);

        if (
          this.formMode == 3 &&
          this.form.status == 1 &&
          this.form.approverIds &&
          this.form.approverIds.indexOf(this.userInfo.id + "") != -1
        ) {
          this.approveDisable = true;
        }

        if (res.returnData.supplierInfos) {
          res.returnData.supplierInfos.map((e) => {
            var supplier = this.STATIC_Suppliers.filter((s) => s.id == e.id);
            if (!supplier || supplier.length == 0) {
              this.STATIC_Suppliers.push(e);
            }
          });
        }

        if (res.returnData.supplierIds) {
          let arr = res.returnData.supplierIds.split(";").map((item) => {
            return +item;
          });
          this.$set(this.form, "supplierIdArr", arr);
        this.getSupplierNames()

        }
      });
    },
    // 保存
    submit () {
      this.$store.dispatch('SetLoading', true)
      var valdateResult = this.productDetailRepeatValidate(this.form.details);
      if (!valdateResult.flag) {
        this.$my_message(valdateResult.msg, "warning");
        this.$store.dispatch('SetLoading', false)
        return;
      }
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          this.$store.dispatch('SetLoading', false)
          return false;
        }
        this.form.supplierIds = this.form.supplierIdArr ?
          this.form.supplierIdArr.join(";") :
          "";
        let supplierProductIds = this.form.details.map((e) => e.supplierProductId);
        // if (!supplierProductIds || supplierProductIds.length == 0) {
        //   this.$my_message("存在没有供应商产品的明细表", "warning")
        //   return
        // }

        ValidateSupplierProducts({
          ids: supplierProductIds,
        })
          .then((res) => {
            if (res.returnData && res.returnData.length > 0) {
              const h = this.$createElement;
              let content = [];
              for (let i = 0; i < this.form.details.length; i++) {
                res.returnData.forEach((item) => {
                  if (this.form.details[i].supplierProductId == item.key) {
                    content.push(
                      h(
                        "p",
                        `第${i + 1}行：产品名称[${this.form.details[i].productName
                        }]，规格型号[${this.form.details[i].specName}]${item.errorMessage
                        }\n`
                      )
                    );
                  }
                });
              }
              content.push(h("p", `不审核仍可下单。`));

              return this.$confirm("提示", {
                title: "提示",
                type: "warning",
                customClass: "promptBox",
                message: h("div", content),
              }).catch(() => {
                this.$store.dispatch('SetLoading', false)
              });
            }
          })
          .then((res) => {
            return this.SaveDataAction(this.form).finally(() => {
              this.$store.dispatch('SetLoading', false)
            });;
          })
          // this.SaveDataAction(this.form)
          .then((res) => {
            this.$my_message(`执行成功`, "success");
            sessionStorage.setItem("editMode", 0);
            // this.$router.push({ path: this.getMainPath(this.$route.path) });
            this.routePushWithParams(
              this.getMainPath(this.$route.path),
              this.$route.params
            );
          }).catch(() => {
            this.$store.dispatch('SetLoading', false)
          });
      });
    },
    resetForm () {
      this.form = {
        inStockType: 0,
        supplierId: "",
        supplierName: "",
        assetCheckNo: "",
        assetCheckId: "",
        state: 0,
        details: [],
        warehouseCategory: "",
        // "warehouseId": this.userInfo.defaultWarehouseId,
        // warehouseName: this.userInfo.defaultWarehouseName,
        warehouseManagerId: this.userInfo.defaultWarehouseManagerId,
        warehouseManagerName: this.userInfo.defaultWarehouseManagerName,
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        supplierIdArr: [],
        supplierIds: "",
        sex: 0,
        sexName: "",
        age: 0,
        state: 1,
        stateName: "待供应商确认",
        totalNumber: 0,
        totalAmount: 0,
        orgCode :sessionStorage.getItem('orgId'),
      };
      this.setDefaultWarehouseBySessionWarehouseId();
    },
    // 取消编辑
    cancel () {
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      // this.$router.push({ path: this.getMainPath(this.$route.path) });
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },

    // 明细表
    handleAddChildForm () {
      this.openSubformModal = true;
      this.editChildren = false;
      this.resetDetailFormData();
      this.form.details.push(this.childForm);

      this.getProductList("");
    },
    handleDeleteChildForm () {
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });

      this.autoTotalAmount();
    },
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    cellDblclick (row, column, cell, event) {
      // 打开子表弹窗
      this.openSubformModal = true;
      this.editChildren = true;
      this.resetDetailFormData();
      this.childForm = JSON.parse(JSON.stringify(row));
    },

    resetDetailFormData () {
      this.childForm = {
        $index: this.form.details.length + 1,
        supplierProductId: "",
        productName: "",
        productId: "",
        specId: "",
        brand: "",
        supplierId: "",
        manufacturerId: "",
        unit: "",
        minUnit: "",
        stockNumber: "",
        undeliveredNumber: 0,
        number: 0,
        price: 0,
        amount: 0,
        remark: "",
        isHaveStock: true,
        packSpec: "",
      };
    },
    cancelChildDialog () {
      this.openSubformModal = false;
    },
    submitChildForm () {
      this.pushChildForm(true);
    },
    continueAdd () {
      this.editChildren = false;
      this.pushChildForm();
      // this.resetDetailFormData();

      this.getProductList("");
    },
    pushChildForm (close) {
      this.$refs["childForm"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.childForm.orgCode = sessionStorage.getItem('orgId')
        // this.capitalSourceChange()
        let item = this.form.details.find(
          (e) =>
            e.$index != this.childForm.$index &&
            e.supplierProductId == this.childForm.supplierProductId //&&
          // e.price == this.childForm.price &&
          // e.locationName == this.childForm.locationName &&
          // e.assetSource == this.childForm.assetSource &&
          // e.packDesc == this.childForm.packDesc &&
          // e.manufacturerId == this.childForm.manufacturerId &&
          // e.certId == this.childForm.certId &&
          // e.brandId == this.childForm.brandId
        );
        if (item && !this.editChildren) {
          // 新增有重复项提示
          // Object.assign(item, this.childForm);
          this.$my_message(`当前产品信息已存在，请去子表编辑！`, "error");
          return;
        } else if (item && this.editChildren) {
          // 编辑且有重复项
          this.$my_message(`当前产品信息已存在，请去子表编辑！`, "error");
          return;
        } else if (!item && this.editChildren) {
          // 编辑
          item = this.form.details.find((e) => e.$index == this.childForm.$index);
          Object.assign(item, this.childForm);
        } else {
          this.form.details.push(this.childForm);
        }

        this.autoTotalAmount();
        this.resetDetailFormData();
        if (close) {
          this.openSubformModal = false;
        }
      });
    },
    childNumberChange (row) {
      row.orderNumber = row.number;
      row.undeliveredNumber = row.number;
      row.unCheckedNumber = row.number;
      row.amount = (row.number * row.price).toFixed(4) * 1;
      // this.autoAmount();
      this.autoTotalAmount();
    },
    autoAmount () {
      this.childForm.amount =
        (this.childForm.number * this.childForm.price).toFixed(4) * 1;
    },
    autoTotalAmount () {
      console.log(234);
      let totalNumber = 0;
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        totalNumber = totalNumber * 1 + element.number * 1;
        totalAmount = totalAmount * 1 + element.amount * 1;
      });
      this.form.totalNumber = totalNumber.toFixed(3) * 1;
      this.form.totalAmount = totalAmount.toFixed(4) * 1;
    },

    // change event
    doctorChange (val) {
      this.form.doctor = val;
      // var arr = this.STATIC_Users.filter(e => e.id == val)
      // this.form.doctorName = arr[0].name
    },
    warehouseChange (val) {
      let arr = this.warehouseList.filter(res=>res.idGroup == val)
      this.form.warehouseName =  arr[0].warehouseName+''+ arr[0].deptName + " " + (arr[0].wardName?arr[0].wardName:'');
      this.form.warehouseId = arr[0].warehouseId
      this.form.deptId = arr[0].deptId
      this.form.wardId = arr[0].wardId
    },
    supplierChange (val) {
      this.form.supplierIds = val.join(";");

      this.getProductList("");
    },
    opChange (val) {
      this.form.surgicalStentId = val;
      let arr = this.opList.filter((item) => item.id == val)[0];
      if (!arr) {
        return;
      }

      this.form.assistant = arr.assistant;
      this.form.phone = arr.phone;
      this.form.surgicalStentName = arr.name + " " + arr.categoryName;
      // this.form.assistant = arr.assistant
      // this.form.phone = arr.phone
      this.form.supplierIds = arr.supplierIds;

      GetSurgicalStentById({
        id: val,
      }).then((res) => {
        var result = res.returnData;
        if (result.supplierInfos) {
          result.supplierInfos.map((item) => {
            var l = this.STATIC_Suppliers.filter((e) => e.id == item.id);
            if (!l || l.length == 0) {
              this.STATIC_Suppliers.push(item);
            }
          });
        }

        if (result.details) {
          this.form.details = result.details;
          this.form.details.map((e, index) => {
            e.$index = index + 1;
            e.orderNumber = e.number
            e.undeliveredNumber = e.number
            e.unCheckedNumber = e.number
            return e;
          });
        }

        if (arr.supplierIds) {
          let at = arr.supplierIds.split(";").map((item) => {
            return +item;
          });
          this.$set(this.form, "supplierIdArr", at);
        }
        this.autoTotalAmount();
      });
    },
    patientChange (val) {
      console.log(val, "patientChange");
      // this.form.patientId = val
      // let arr = this.STATIC_PatientDetails.filter(item => item.no == val)[0]
      let arr = this.STATIC_PatientDetails.filter((item) => item.id == val)[0];
      if (arr) {
        this.form.patientName = arr.name;
        this.form.patientId = arr.id;
        this.form.patientNo = arr.no;
        this.form.sex = arr.sex;
        this.form.sexName = arr.sexName;
        this.form.age = this.jsGetAge(arr.birthday);
      } else {
        this.form.patientName = "";
        this.form.patientId = "";
        this.form.patientNo = "";
        this.form.sex = "";
        this.form.sexName = "";
        this.form.age = "";
      }
    },
    productChange (row, val) {
      let id = row.id;
      row = Object.assign(row, val);
      row.id = id;
      row.supplierProductId = val.id;
      row.number = 1;
      row.stockNumber = 0;
      row.undeliveredNumber = row.number;
      row.unCheckedNumber = row.number;
      row.orderNumber = row.number;
      row.price = row.purchasePrice;
      row.amount = row.price * row.number;
      row.supplierProductNo = row.no;
      row.remark = "";

      this.autoTotalAmount();

      setTimeout(() => {
        document.getElementById("number" + (row.$index - 1)).focus();
        document.getElementById("number" + (row.$index - 1)).select();
      }, 1);
    },
    inputChange (row) {
      row.amount = row.price * row.number;
      this.autoTotalAmount();
    },
    oneLevelWarehouseChange (val) {
      this.form.oneLevelWarehouseId = val;
      let arr = this.STATIC_OneLevelWarehouses.filter((item) => item.id == val);
      this.form.oneLevelWarehouseManagerId = arr ? arr[0].managerId : "";
    },
    applyDeptChange1 (val) {
      let arr = this.STATIC_Depts.filter(res => res.idGroup == val)
      this.form.warehouseName = arr[0].warehouseName + '' + arr[0].deptName + " " + (arr[0].wardName ? arr[0].wardName : '');
      this.form.warehouseId = arr[0].warehouseId
      this.form.deptId = arr[0].deptId
      this.form.wardId = arr[0].wardId
      this.getLocations(this.form.warehouseId);
    },
    getOpList (keyWord) {
      var query = {
        keyWord: keyWord,
        pageSize: 100,
        pageIndex: 1,
        Status: 2,
        loginDeptId: this.mySessionStorage.getDeptId(),
        loginWarehouseId: this.mySessionStorage.getWarehouseId(),
      };
      GetSurgicalStents(query).then((res) => {
        this.opList = res.returnData.data;
      });
    },
    getProductList (keyWord) {
      var user = this.userInfo;
      // query.pageSize = 100
      // query.pageIndex = 1
      // query.isEnabled = 1
      // query.supplierId = this.form.supplierId
      // query.deptId = user.deptId
      // query.stockCategory = 2
      this.getSupplierProducts(
        //query)
        {
          keyWord: keyWord,
          pageSize: 100,
          pageIndex: 1,
          isEnabled: 1,
          supplierId: this.form.supplierId,
          deptId: user.deptId,
          stockCategory: 2,
          status: 2,
        }
      );
    },

    confirmOrder () {
      this.$confirm("接单数量不等于申请数量，是否继续申请？", "提示", {
        type: "warning",
      })
        .then(() => {
          return ConfirmSurgicalApply({
            id: this.form.id,
          });
        })
        .then((res) => {
          if (res.successful) {
            this.cancel();
            this.$my_message(` 提交成功`, "success");
          }
        });
    },
    cancelOrder () {
    
          return CancelSurgicalApply({
            id: this.form.id,
          })
        .then((res) => {
          if (res.successful) {
            this.cancel();
            this.$my_message(` 提交成功`, "success");
          }
        });
    },

    getWarehouseList:Debounce(function (keyWord) {
      return new Promise((resolve, reject) => {
        GetWarehousesDepts({
          keyWord: keyWord,
          state: 1,
          
        }).then((response) => {
          if (response && response.returnData) {
            this.warehouseList = response.returnData.data;
            resolve(response.returnData);
          } else {
            reject(response);
          }
        });
      });
    }, 500),
    
    getSupplierNames () {
      this.$nextTick(()=>{
        let names = this.form.supplierIdArr.map(item => this.STATIC_Suppliers.find(res => res.id == item)?.name)        
        this.SupplierNames =  names.join('、')        
      })

    },
      // GetDeptWarehouses({ keyWord: keyWord, state: 1 })
      //     this.warehouseList = res.returnData;
      //   })
     
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}

/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
</style>

<style>
.promptBox {
  width: 800px !important;
  max-height: 300px;
}
</style>
